import { useChatClass } from "../../theme";
import { formatTimestamp } from "./utils";
import { Container } from "./styled";

export interface TimestampProps {
  /** A timestamp in milliseconds since unix epoch. */
  value: number;
  /** Optional preformatted display text. */
  label?: string;
}

interface TimestampComponent extends React.FC<TimestampProps> {
  Container: typeof Container;
}

/** Formats and styles a timestamp as 12-hour time. */
const Timestamp: TimestampComponent = ({ value, label }) => {
  const chatClass = useChatClass();
  return (
    <Container className={chatClass("timestamp")}>
      {label || formatTimestamp(value)}
    </Container>
  );
};

Timestamp.Container = Container;

export { Timestamp };
